import { API, DISPLAY } from '../config'

export let apiUrl = (version) => `${API}/api/${version || 'v2'}`;
export const mygeotabUrl = 'https://my.geotab.com/apiv1'
export const driverMapUrl = 'https://partners.api.drivertechnologies.io'

export const originUrl = () => `${(API, DISPLAY)}`
